import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/yoybuy-spreadsheet-instruktsiya",
    element: <BlogPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;